import { IUpdateIndicadoresUseCase } from "../../../presentation/useCases/update/updade_indicadores_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// UpdateIndicadoresUseCase

export class UpdateIndicadoresUseCase implements IUpdateIndicadoresUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async updateIndicadores(IdIndicador: number, Item: string | null, Descricao: string | null, Indice: string | null, Frequencia: string | null, Meta: string | null, Ativo: boolean | null, Resultado: string | null
  ): Promise<void> {
    
    await this.repository.updateIndicadores(
      IdIndicador, Item, Descricao, Indice, Frequencia, Meta, Ativo, Resultado
    );
  }
}
